import { tUi } from '../i18n';

export type DayHours = { open: string; close: string };

export type OperatingHours = Record<string, DayHours>;

export const WEEKDAYS = [
  { key: 'monday', get label() { return tUi('weekday.monday'); } },
  { key: 'tuesday', get label() { return tUi('weekday.tuesday'); } },
  { key: 'wednesday', get label() { return tUi('weekday.wednesday'); } },
  { key: 'thursday', get label() { return tUi('weekday.thursday'); } },
  { key: 'friday', get label() { return tUi('weekday.friday'); } },
  { key: 'saturday', get label() { return tUi('weekday.saturday'); } },
  { key: 'sunday', get label() { return tUi('weekday.sunday'); } },
] as const;

export const DEFAULT_OPERATING_HOURS: OperatingHours = {
  monday: { open: '08:00', close: '17:00' },
  tuesday: { open: '08:00', close: '17:00' },
  wednesday: { open: '08:00', close: '17:00' },
  thursday: { open: '08:00', close: '17:00' },
  friday: { open: '08:00', close: '17:00' },
  saturday: { open: '08:00', close: '17:00' },
  sunday: { open: '08:00', close: '17:00' },
};

/** Empty/missing stored hours → full default week; otherwise missing days = closed. */
export function resolveOperatingHours(
  hours: OperatingHours | null | undefined
): OperatingHours {
  if (!hours || Object.keys(hours).length === 0) {
    return { ...DEFAULT_OPERATING_HOURS };
  }
  return { ...hours };
}

export function isDayOpen(hours: OperatingHours, dayKey: string): boolean {
  return Boolean(hours[dayKey]);
}

export function setDayClosed(hours: OperatingHours, dayKey: string): OperatingHours {
  const next = { ...hours };
  delete next[dayKey];
  return next;
}

export function setDayOpen(
  hours: OperatingHours,
  dayKey: string,
  open = '08:00',
  close = '17:00'
): OperatingHours {
  return { ...hours, [dayKey]: { open, close } };
}

export function updateDayHours(
  hours: OperatingHours,
  dayKey: string,
  field: 'open' | 'close',
  value: string
): OperatingHours {
  const current = hours[dayKey] ?? { open: '08:00', close: '17:00' };
  return {
    ...hours,
    [dayKey]: { ...current, [field]: value },
  };
}

export function formatDayHours(hours: OperatingHours, dayKey: string): string {
  const day = hours[dayKey];
  if (!day) return tUi('closed');
  return `${day.open} – ${day.close}`;
}
